import { IObjectResponse } from 'shared/models/IResponse'
import { VasModel } from 'shared/models/Vas/VasModel'
import { ServiceBase } from './ServiceBase'

export default class VasService extends ServiceBase {
  public static async getAllVasCodesForWarehouse(
    warehouseId: number
  ): Promise<IObjectResponse<VasModel[]>> {
    const result = await this.get<VasModel[]>(`/Vas/${warehouseId}`)
    return result
  }
}
